/**
 * Permission constants for the application
 */
export const PERMISSIONS = {
  HAS_ACCESS_TO_ORG_ADMIN: "iam:all"
} as const;
